<template>
    <div>
        <label for="identification_code">Identification Code</label>
        <div class="input-group">
            <input id="identification_code" type="text" class="form-control" name="identification_code" v-model="code">
            <div class="input-group-append" data-toggle="tooltip" title="Search Payer Identification Codes">
                <button type="button" class="btn btn-primary btn-sm" @click="search()"><i class="fas fa-search fa-lg"></i></button>
            </div>
        </div>

        <div id="search-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search Payer Identification Codes</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>                        
                    </div>
                    <div class="modal-body">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fas fa-search fa-lg text-muted"></i></div>
                            </div>
                            <input type="text" class="form-control" placeholder="Search Payer Identification Codes" v-model="searchString">
                        </div>                         
                        <div class="list-group list-group-scroll">
                            <template v-for="payer in filteredPayers">
                                <button type="button" class="list-group-item list-group-item-action" :key="payer.code" @click="select(payer.code)">
                                    <div class="row" style="line-height: 1">
                                        <div class="col-auto">{{ payer.code }}</div>
                                        <div class="col">{{ payer.name }}</div>
                                    </div>                   
                                </button>
                            </template>
                        </div>                         
                    </div>
                    <div class="modal-footer">

                    </div>                                     
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        identificationCode: String,
        payers: Array
    },
    data() {
        return {
            code: this.identificationCode,
            searchString: ''
        }
    },
    computed: {
        filteredPayers: function () {
            var self = this;
            return self.payers.filter(function(payer) {
                return (payer.name.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1);
            });            
        }
    },
    methods: {
        search: function () {
            $('#search-modal').modal('show');
        },
        select: function (code) {
            this.code = code;
            $('#search-modal').modal('hide');
        }
    }
}
</script>

<style scoped>
    .list-group-scroll {
        max-height: 500px; 
        overflow: scroll; 
        -webkit-overflow-scrolling: touch;
    }
</style>